// 中文（简体）翻译

const zh = {
  "hotel.folio": "账单",
  "hotel.folio.registration_state": "登记状态",
  "hotel.folio.room": "房间",
  "hotel.folio.main_guest": "主要住客",
  "hotel.folio.nights_quantity": "晚数",
  "hotel.folio.arrival_date": "到达日期",
  "hotel.folio.departure_date": "离店日期",
  "hotel.folio.notes": "备注",
  "hotel.folio.breakfast_included": "含早餐",
  "hotel.folio.check_in": "入住",
  "hotel.folio.check_out": "退房",
  "hotel.folio.reverse_checkout": "撤销退房",
  "hotel.folio.confirm": "确认",
  "hotel.folio.pending": "待处理",
  "hotel.folio.booking": "预订",
  "hotel.folio.contact": "联系方式",
  "hotel.folio.registration_card": "登记卡",
  "hotel.folio.product": "服务",
  "hotel.folio.unit_price": "单价",
  "hotel.folio.channel": "渠道",
  "hotel.folio.group": "团队",
  "hotel.folio.total_amount": "总金额",
  "hotel.folio.bed_breakfast": "住宿加早餐",
  "hotel.folio.no_breakfast": "不含早餐",
  "hotel.folio.all_inclusive": "全包",
  "hotel.folio.full_american": "全餐",
  "hotel.folio.half_american": "半餐",
  "hotel.folio.num_adults": "成人数量",
  "hotel.folio.num_children": "儿童数量",
  "hotel.folio.number": "编号",
  "hotel.folio.pax": "人数",
  "hotel.folio.charge.folio": "账单",
  "hotel.folio.charge.order": "订单",
  "hotel.folio.charge.kind": "类型",
  "hotel.folio.charge.invoice_line": "发票",
  "hotel.folio.charge.draft": "草稿",
  "hotel.folio.occupancy": "入住情况",
  "hotel.folio.occupancy.occupancy_date": "日期",
  "hotel.folio.occupancy.unit_price": "单价",
  "hotel.folio.occupancy.unit_price_w_tax": "含税单价",
  "hotel.folio.occupancy.charge": "收费",
  "hotel.folio.occupancy.state": "状态",
  "hotel.folio.occupancy.draft": "草稿",
  "hotel.folio.occupancy.confirmed": "已确认",
  "hotel.folio.occupancy.invoiced": "已开票",
  "hotel.folio.guest.city": "城市",
  "sale.line.unit_price_w_tax": "价格 + 税",
};

export default zh;
